import { LayoutHOC } from "base/ui/layout/layout";
import AddCatalog from "./AddCatalog";

export const createAddCatalog = (layoutHOC: LayoutHOC) => {
  return layoutHOC(AddCatalog());
};
